<template lang="pug">
.v-radio-list.radio-list(:class="{'radio-list--disabled': field.disabled}, field.className")
	label.radio-list__label(v-if="field.label" :id="uniqueId")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	.radio-list__item.flc(v-for="(option, index) in field.options" :key="option.value + '-' + index")
		v-field-checkbox(
				:true-value="option.value"
				:text="option.text"
				:icon="option?.icon"
				:disabled="option.disabled || field.disabled"
				v-model="localValue"
				@update:model-value="handleInput"
				:radio="radio")
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	props: {
		radio: {
			type: Boolean,
			default: false
		},

		field: {
			type: Object,
			required: true,
			default: null
		},

		modelValue: {
			type: [Object, String, Number],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			open: false,
			uniqueId: uniqueId('field-')
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
		}
	},
};
</script>
